export default __webpack_public_path__ + "static/wincasa-b4b1b7477fa24b81b6384c80ac0416ec.png";